const links = [
  ["HERO", "top"],
  ["ABOUT", "about"],
  ["SKILLS", "skills"],
  ["EXPERIENCE", "experience"],
  ["CONTACT", "contact"],
];
// ["PROJECTS", "projects"],

function Navigation({ onPowerToggle, poweredOn }) {
  const handleNavigation = (event) => {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute("href")?.slice(1);
    const target = document.getElementById(targetId);

    target?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav className="site-nav" aria-label="Primary navigation">
      {poweredOn
        ? links.map(([label, id]) => (
            <a href={`#${id}`} key={id} onClick={handleNavigation}>
              {label}
            </a>
          ))
        : null}
      <a
        href="#top"
        onClick={(event) => {
          handleNavigation(event);
          onPowerToggle(event);
        }}
      >
        {poweredOn ? "SHUTDOWN" : "POWER ON"}
      </a>
    </nav>
  );
}

export default Navigation;
